import { gql } from "apollo-boost";

export const MEET_MERGE = gql`
  mutation meetMerge(
    $meetId: Int
    $meetName: String!
    $meetDesc: String!
    $contactInfo: String!
    $meetType: String!
    $meetDate: Date!
    $meetDateTo: Date
    $sport: String
    $urlToDetails: String
    $state: String
    $tag: String
    $leagueSeqno: Int!
    $userId: Int
    $facilityId: Int
    $updateSource: String!
  ) {
    meetMerge(
      meetData: {
        meetId: $meetId
        meetName: $meetName
        meetDesc: $meetDesc
        contactInfo: $contactInfo
        meetType: $meetType
        meetDate: $meetDate
        meetDateTo: $meetDateTo
        sport: $sport
        urlToDetails: $urlToDetails
        state: $state
        tag: $tag
        leagueSeqno: $leagueSeqno
        userId: $userId
        facilityId: $facilityId
        updateSource: $updateSource
      }
    ) {
      node {
        meetId
        meetName
        meetDesc
        contactInfo
        meetType
        meetDate
        meetDateTo
        sport
        urlToDetails
        state
        tag
        facilityId
        leagueSeqno
        updateSource
        userId
      }
    }
  }
`;

export const DELETE_MEET = gql`
  mutation meetDelete($meetId: Int!) {
    meetDelete(meetId: $meetId) {
      status
    }
  }
`;
